import { Injectable } from '@angular/core';
import { CommonService } from '../shared/services/bulk-maintenance/common.service';
import { BULK_MAINTENANCE_ERROR_MESSAGES } from '../shared/services/bulk-maintenance/bulk-maintenance-error-messages';

@Injectable({
  providedIn: 'root'
})
export class CapitaldemandBulkService {

  constructor(private commonService: CommonService) { }


  public compareData(item1: any, item2: any, requiredHeaders: string[]) {
    for (const key of requiredHeaders) {
      if (item1[key] !== item2[key]) {
        return false;
      }
    }
    return true;
  }

  public findDuplicatesAndUniqueRecords(dataset: any[], uniqueHeaders: string[]) {
    const seen = new Map();
    const uniqueRecords = [];
    const duplicates = [];

    for (const data of dataset) {
      const key = uniqueHeaders.map(header => data[header]).join('|');

      if (seen.has(key)) {
        // Mark both current and previously seen record as duplicate
        data['Status'] = 'FAIL';
        data['Message'] = BULK_MAINTENANCE_ERROR_MESSAGES.COMMON.DUPLICATE_RECORD;

        const original = seen.get(key);
        if (original['Status'] !== 'FAIL') {
          original['Status'] = 'FAIL';
          original['Message'] = BULK_MAINTENANCE_ERROR_MESSAGES.COMMON.DUPLICATE_RECORD;
          duplicates.push(original);
          // uniqueRecords = this.deleteObjectFromArray(uniqueRecords, original);
        }

        duplicates.push(data);
      } else {
        seen.set(key, data);
        uniqueRecords.push(data);
      }
    }

    // const testRecords = uniqueRecords.filter(record => record['Status'] !== 'FAIL');
    for (const item of uniqueRecords) {
      if (item['Status'] === 'FAIL') {
        uniqueRecords.splice(uniqueRecords.indexOf(item), 1);
      }
    }
    return { uniqueRecords: uniqueRecords, duplicates };
}


  public validateFields(ele: any, index: number) {
    ele['rowNum'] = index;

    let requiredFields = [
      {
        key: 'Update Type',
        message: BULK_MAINTENANCE_ERROR_MESSAGES.CAPITAL_DEMAND_BULK.UPDATE_TYPE_REQUIRED,
        nullCheck: true
      },
      {
        key: 'Update Type',
        message: BULK_MAINTENANCE_ERROR_MESSAGES.CAPITAL_DEMAND_BULK.UPDATE_TYPE_INVALID,
        validCheck: true
      },
      {
        key: 'Funding SegmentID',
        message: BULK_MAINTENANCE_ERROR_MESSAGES.CAPITAL_DEMAND_BULK.FUNDING_SEGMENT_ID_REQUIRED,
        nullCheck: true
      },
      {
        key: 'UCMG ID',
        message: BULK_MAINTENANCE_ERROR_MESSAGES.CAPITAL_DEMAND_BULK.UCMG_ID_REQUIRED,
        nullCheck: true
      },
      {
        key: 'Fiscal Year',
        message: BULK_MAINTENANCE_ERROR_MESSAGES.CAPITAL_DEMAND_BULK.FISCAL_YEAR_REQUIRED,
        nullCheck: true
      },
      {
        key: 'L1 MSID',
        message: BULK_MAINTENANCE_ERROR_MESSAGES.CAPITAL_DEMAND_BULK.L1_MSID_REQUIRED,
        nullCheck: true
      },
      {
        key: 'L2 MSID',
        message: BULK_MAINTENANCE_ERROR_MESSAGES.CAPITAL_DEMAND_BULK.L2_MSID_REQUIRED,
        nullCheck: true
      },
      {
        key: 'L3 MSID',
        message: BULK_MAINTENANCE_ERROR_MESSAGES.CAPITAL_DEMAND_BULK.L3_MSID_REQUIRED,
        nullCheck: true
      },
      {
        key: 'OT Labor',
        message: BULK_MAINTENANCE_ERROR_MESSAGES.CAPITAL_DEMAND_BULK.OT_LABOR_REQUIRED,
        nullCheck: true
      }
    ];
    let obj = this.commonService.initializeValidationObject();

    // Check if row already has a fail status
    if (ele['Status'] && ele['Status'].toLowerCase() == 'fail') {
      return this.commonService.createErrorObject(index, ele['Message']);
    }

    // Perform all validations
    obj = this.commonService.validateFieldsAndUpdateType(requiredFields, ele, index, obj, ['U', 'A', 'D']);
    if (obj.status === false) {
      ele['Status'] = 'Fail';
      ele['Message'] = obj.message;
    } else {
      ele['Status'] = 'Success';
      ele['Message'] = '';
    }
    return ele;

  }

  public validateRecord(excelData: any[], type: string, uniqueHeaders: string[]) {
    try{
    const clonedExcelData = excelData.map(el => ({ ...el }));

    const { uniqueRecords, duplicates } = this.findDuplicatesAndUniqueRecords(clonedExcelData, uniqueHeaders); // { uniqueRecords, duplicates }
    const totalRecords = [];
    for (const [index, item] of uniqueRecords.entries()) {
      const validatedRecord = (type === 'ucmg'
        ? this.validateFiledsUCMG(item, index)
        : this.validateFields(item, index));
      totalRecords.push(validatedRecord);
    }
    return { successRecords:totalRecords, duplicateRecords: duplicates }; 
   }
    catch (error) {
      console.error(BULK_MAINTENANCE_ERROR_MESSAGES.CAPITAL_DEMAND_BULK.VALIDATION_FAILED_PREFIX, error);
      throw error;
    }
  }

  public validateFiledsUCMG(ele: any, index: number) {
    // Always initialize to avoid "requiredFields is not iterable" when Update Type is blank/unknown
    let requiredFields: any[] = [
      {
        key: 'Update Type',
        message: BULK_MAINTENANCE_ERROR_MESSAGES.CAPITAL_DEMAND_BULK.UPDATE_TYPE_REQUIRED,
        nullCheck: true
      },
      {
        key: 'Update Type',
        message:
          BULK_MAINTENANCE_ERROR_MESSAGES.CAPITAL_DEMAND_BULK
            .UPDATE_TYPE_INVALID_WITH_ROLES,
        validCheck: true
      }
    ];
    ele['rowNum'] = index;
    ele['Update Type'] = ele['Update Type'] && ele['Update Type'].toString().toUpperCase().trim();

    const defaultZeroFields = [
      'Optum Tech Labor',
      'Advisory Services',
      'Business Labor',
      'Hardware/Software',
      'Professional Fees',
      'Other Chargebacks'
    ];
    for (const field of defaultZeroFields) {
      if (this.commonService.NullCheck(ele[field])) {
        ele[field] = '0';
      }
    }

    if (ele['Update Type'] == 'ROLES_UPDATE') {
      ele['Update Type'] = 'Roles_Update';
      requiredFields = [
      {
        key: 'Update Type',
        message: BULK_MAINTENANCE_ERROR_MESSAGES.CAPITAL_DEMAND_BULK.UPDATE_TYPE_REQUIRED,
        nullCheck: true
      },
      {
        key: 'Update Type',
        message:
          BULK_MAINTENANCE_ERROR_MESSAGES.CAPITAL_DEMAND_BULK
            .UPDATE_TYPE_INVALID_WITH_ROLES,
        validCheck: true
      },
      {
        key: 'UCMG ID',
        message: BULK_MAINTENANCE_ERROR_MESSAGES.CAPITAL_DEMAND_BULK.UCMG_ID_REQUIRED,
        nullCheck: true
      }
      ];
    }
    if (ele['Update Type'] == 'D') {
      requiredFields = [
        {
          key: 'Update Type',
          message: BULK_MAINTENANCE_ERROR_MESSAGES.CAPITAL_DEMAND_BULK.UPDATE_TYPE_REQUIRED,
          nullCheck: true
        },
        {
          key: 'Update Type',
          message:
            BULK_MAINTENANCE_ERROR_MESSAGES.CAPITAL_DEMAND_BULK
              .UPDATE_TYPE_INVALID_WITH_ROLES,
          validCheck: true
        },
        {
          key: 'UCMG ID',
          message: BULK_MAINTENANCE_ERROR_MESSAGES.CAPITAL_DEMAND_BULK.UCMG_ID_REQUIRED,
          nullCheck: true
        },
        {
          key: 'Fiscal Year',
          message: BULK_MAINTENANCE_ERROR_MESSAGES.CAPITAL_DEMAND_BULK.FISCAL_YEAR_REQUIRED,
          nullCheck: true
        },
      ];
    }
    if (ele['Update Type'] == 'U') {
      requiredFields = [
        {
          key: 'Update Type',
          message: BULK_MAINTENANCE_ERROR_MESSAGES.CAPITAL_DEMAND_BULK.UPDATE_TYPE_REQUIRED,
          nullCheck: true
        },
        {
          key: 'Update Type',
          message:
            BULK_MAINTENANCE_ERROR_MESSAGES.CAPITAL_DEMAND_BULK
              .UPDATE_TYPE_INVALID_WITH_ROLES,
          validCheck: true
        },
        {
          key: 'UCMG ID',
          message: BULK_MAINTENANCE_ERROR_MESSAGES.CAPITAL_DEMAND_BULK.UCMG_ID_REQUIRED,
          nullCheck: true
        },
        {
          key: 'Fiscal Year',
          message: BULK_MAINTENANCE_ERROR_MESSAGES.CAPITAL_DEMAND_BULK.FISCAL_YEAR_REQUIRED,
          nullCheck: true
        },
        {
          key: 'Optum Tech Labor',
          message: BULK_MAINTENANCE_ERROR_MESSAGES.CAPITAL_DEMAND_BULK.OPTUM_TECH_LABOR_REQUIRED,
          nullCheck: true
        }, 
        {
          key: 'Advisory Services',
          message: BULK_MAINTENANCE_ERROR_MESSAGES.CAPITAL_DEMAND_BULK.ADVISORY_SERVICES_REQUIRED,
          nullCheck: true
        }, 
        {
          key: 'Business Labor',
          message: BULK_MAINTENANCE_ERROR_MESSAGES.CAPITAL_DEMAND_BULK.BUSINESS_LABOR_REQUIRED,
          nullCheck: true
        }, 
        {
          key: 'Hardware/Software',
          message: BULK_MAINTENANCE_ERROR_MESSAGES.CAPITAL_DEMAND_BULK.HARDWARE_SOFTWARE_REQUIRED,
          nullCheck: true
        }, 
        {
          key: 'Professional Fees',
          message: BULK_MAINTENANCE_ERROR_MESSAGES.CAPITAL_DEMAND_BULK.PROFESSIONAL_FEES_REQUIRED,
          nullCheck: true
        }, 
        {
          key: 'Other Chargebacks',
          message: BULK_MAINTENANCE_ERROR_MESSAGES.CAPITAL_DEMAND_BULK.OTHER_CHARGEBACKS_REQUIRED,
          nullCheck: true
        }, 
      ];
    }
    if (ele['Update Type'] == 'A') {
      requiredFields = [
        {
          key: 'Update Type',
          message: BULK_MAINTENANCE_ERROR_MESSAGES.CAPITAL_DEMAND_BULK.UPDATE_TYPE_REQUIRED,
          nullCheck: true
        },
        {
          key: 'Update Type',
          message:
            BULK_MAINTENANCE_ERROR_MESSAGES.CAPITAL_DEMAND_BULK
              .UPDATE_TYPE_INVALID_WITH_ROLES,
          validCheck: true
        },
        {
          key: 'Funding SegmentID',
          message: BULK_MAINTENANCE_ERROR_MESSAGES.CAPITAL_DEMAND_BULK.FUNDING_SEGMENT_ID_REQUIRED,
          nullCheck: true
        },
        {
          key: 'UCMG ID',
          message: BULK_MAINTENANCE_ERROR_MESSAGES.CAPITAL_DEMAND_BULK.UCMG_ID_REQUIRED,
          nullCheck: true
        },
        {
          key: 'UCMG',
          message: BULK_MAINTENANCE_ERROR_MESSAGES.CAPITAL_DEMAND_BULK.UCMG_REQUIRED,
          nullCheck: true
        },
        {
          key: 'Fiscal Year',
          message: BULK_MAINTENANCE_ERROR_MESSAGES.CAPITAL_DEMAND_BULK.FISCAL_YEAR_REQUIRED,
          nullCheck: true
        },
        {
          key: 'Optum Tech Labor',
          message: BULK_MAINTENANCE_ERROR_MESSAGES.CAPITAL_DEMAND_BULK.OPTUM_TECH_LABOR_REQUIRED,
          nullCheck: true
        }, 
        {
          key: 'Advisory Services',
          message: BULK_MAINTENANCE_ERROR_MESSAGES.CAPITAL_DEMAND_BULK.ADVISORY_SERVICES_REQUIRED,
          nullCheck: true
        }, 
        {
          key: 'Business Labor',
          message: BULK_MAINTENANCE_ERROR_MESSAGES.CAPITAL_DEMAND_BULK.BUSINESS_LABOR_REQUIRED,
          nullCheck: true
        }, 
        {
          key: 'Hardware/Software',
          message: BULK_MAINTENANCE_ERROR_MESSAGES.CAPITAL_DEMAND_BULK.HARDWARE_SOFTWARE_REQUIRED,
          nullCheck: true
        }, 
        {
          key: 'Professional Fees',
          message: BULK_MAINTENANCE_ERROR_MESSAGES.CAPITAL_DEMAND_BULK.PROFESSIONAL_FEES_REQUIRED,
          nullCheck: true
        }, 
        {
          key: 'Other Chargebacks',
          message: BULK_MAINTENANCE_ERROR_MESSAGES.CAPITAL_DEMAND_BULK.OTHER_CHARGEBACKS_REQUIRED,
          nullCheck: true
        }, 
        {
          key: 'Investment Status',
          message:
            BULK_MAINTENANCE_ERROR_MESSAGES.CAPITAL_DEMAND_BULK
              .INVESTMENT_STATUS_REQUIRED,
          nullCheck: true
        }
      ];
    }
    let obj = this.commonService.initializeValidationObject();

    // Check if row already has a fail status
    if (ele['Status'] && ele['Status'].toLowerCase() == 'fail') {
      return this.commonService.createErrorObject(index, ele['Message']);
    }

    // Perform all validations
    obj = this.commonService.validateFieldsAndUpdateType(requiredFields, ele, index, obj, ['U', 'A', 'D', 'ROLES_UPDATE', 'Roles_Update']);
    if (obj.status === false) {
      ele['Status'] = 'Fail';
      ele['Message'] = obj.message;
    } else {
      ele['Status'] = 'Success';
      ele['Message'] = '';
    }

    if(ele['Fiscal Year']){
      this.commonService.validateFiscalYearField(ele, 'Fiscal Year', 'Fiscal Year');
    }
    ele['Investment Status'] = ele['Investment Status'].toUpperCase().trim();
    let invstStatusValidation = this.commonService.allowedValueCheck(ele['Investment Status'], ['ACTIVE', 'INACTIVE']);
    if (!invstStatusValidation && (ele['Investment Status'] != '')) {
      ele['Status'] = 'Fail';
      const msg = BULK_MAINTENANCE_ERROR_MESSAGES.CAPITAL_DEMAND_BULK.INVESTMENT_STATUS_INVALID;
      ele['Message'] = ele['Message'] ? `${ele['Message']}, ${msg}` : msg;
    }
    // this.commonService.validateRequiredIntegerField(ele, 'Total Forecast', 'Total Forecast');
    if(ele['Optum Tech Labor']){
      this.commonService.validateRequiredIntegerField(ele, 'Optum Tech Labor', 'Optum Tech Labor');
    }
    if(ele['Professional Fees']){
      this.commonService.validateRequiredIntegerField(ele, 'Professional Fees', 'Professional Fees');
    }
    if(ele['Advisory Services']){
      this.commonService.validateRequiredIntegerField(ele, 'Advisory Services', 'Advisory Services');
    }
    if(ele['Business Labor']){
      this.commonService.validateRequiredIntegerField(ele, 'Business Labor', 'Business Labor');
    }
    if(ele['Hardware/Software']){
      this.commonService.validateRequiredIntegerField(ele, 'Hardware/Software', 'Hardware/Software');
    }
    if(ele['Other Chargebacks']){
      this.commonService.validateRequiredIntegerField(ele, 'Other Chargebacks', 'Other Chargebacks');
    }
    return ele;

  }

}
